import DOMPurify from "isomorphic-dompurify";

export const transformObjectToArray = (
  obj: Record<string, string>
): { name: string; link: string }[] => {
  return Object.entries(obj).map(([name, link]) => ({ name, link }));
};

export const HighlightedHeading: React.FC<{ title: string }> = ({ title }) => {
  if (!title) return null;

  const formatTitle = (title: string): string => {
    return title
      .replace(/{purple}/g, '<span style="color: #7C47E1;">')
      .replace(/{\/purple}/g, "</span>");
  };

  const sanitizedTitle = DOMPurify.sanitize(formatTitle(title));

  return <div dangerouslySetInnerHTML={{ __html: sanitizedTitle }} />;
};

// this fxn just provide a sample variant name from variant list
// needed for sampleVariantName in variantNotFound Modal
export const getFirstVariantName = (data: any) => {
  for (const key in data) {
    if (data[key].length > 0) {
      return data[key]?.[0]?.name;
    }
  }
  return null; 
};
